import type { PromotionResponse } from '@/services/promotionsApi'

export interface PromotionBadge {
  label: string
  detail: string
  tone: 'amber' | 'emerald' | 'slate'
}

export function getProductPromotionBadge(promotion?: Pick<PromotionResponse, 'active' | 'lifecycleStatus' | 'discountPct' | 'discountAmt' | 'name'> | null): PromotionBadge | null {
  if (!promotion || !promotion.active || promotion.lifecycleStatus !== 'current') {
    return null
  }

  const detail =
    promotion.discountPct !== null && promotion.discountPct !== undefined
      ? `${promotion.discountPct}%`
      : promotion.discountAmt !== null && promotion.discountAmt !== undefined
        ? 'Monto fijo'
        : 'Activa'

  return {
    label: 'Promo activa',
    detail,
    tone: 'amber',
  }
}
